import PropTypes from 'prop-types';

// material-ui
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

// project import
import NavItem from './NavItem';
import { useGetMenuMaster } from 'api/menu';

// assets
import DownOutlined from '@ant-design/icons/DownOutlined';
import RightOutlined from '@ant-design/icons/RightOutlined';

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

export default function NavGroup({ item, open, onToggle }) {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const hasTitle = Boolean(item.title);

  const navCollapse = item.children?.map((menuItem) => {
    switch (menuItem.type) {
      case 'collapse':
        return (
          <Typography key={menuItem.id} variant="caption" sx={{ p: 2.5, color: 'error.main' }}>
            collapse - only available in paid version
          </Typography>
        );
      case 'item':
        return <NavItem key={menuItem.id} item={menuItem} level={1} />;
      default:
        return (
          <Typography key={menuItem.id} variant="h6" sx={{ color: 'error.main', textAlign: 'center' }}>
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  if (!hasTitle) {
    return (
      <List sx={{ mb: drawerOpen ? 1.5 : 0, py: 0, zIndex: 0 }}>
        {navCollapse}
      </List>
    );
  }

  return (
    <List sx={{ mb: drawerOpen ? 1 : 0, py: 0, zIndex: 0 }}>
      {drawerOpen && (
        <ListItemButton
          onClick={() => onToggle(item.id)}
          sx={{
            mx: 1.5,
            mb: 0.5,
            borderRadius: 1,
            color: 'text.secondary',
            '&:hover': { bgcolor: 'action.hover', color: 'text.primary' }
          }}
        >
          <ListItemText
            primary={
              <Typography variant="subtitle2" sx={{ color: 'inherit' }}>
                {item.title}
              </Typography>
            }
          />
          {open ? <DownOutlined style={{ fontSize: '0.75rem' }} /> : <RightOutlined style={{ fontSize: '0.75rem' }} />}
        </ListItemButton>
      )}
      <Collapse in={open || !drawerOpen} timeout="auto" unmountOnExit>
        {navCollapse}
      </Collapse>
    </List>
  );
}

NavGroup.propTypes = { item: PropTypes.object, open: PropTypes.bool, onToggle: PropTypes.func };
